// tslint:disable:variable-name

export * from './ui/components/shimmer/models/color.model';
export * from './ui/layouts/app-layout/models/nav-mode.model';